import { faBuilding } from '@fortawesome/pro-solid-svg-icons';

import { NavRoute } from '../../shared/navigation/nav.route.interface';

export const getMainNavSite: () => NavRoute = () => { 
	return { 
		name: "Sites"
		, security: security => security.coreFeatures
        , path: 'sites/by-event'
        , icon: faBuilding
        , area: 'sites'
        , expanded: globalThis.location.href.includes("/sites/")
		, children: [
			{
				name: 'By Event'
				, exact: true
				, path: 'sites/by-event'
                , activeNavLink: 'sites/by-event'
		        , secondaryNav: ['Sites', 'By Event']
			}
		]
	};
};
